// src/reducer.js
import * as actionTypes from './actionTypes';

const initialState = {
  allData: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_CURRENT_PRODUCT_DETAIL:
      state = {
        ...state,
        allData: action.payload,
      };
      break;
    case actionTypes.REMOVE_CURRENT_PRODUCT_DETAIL:
      state = { allData: [] }
      break;
    default:
      state = { ...state };
  }
  return state;
};

export default reducer;
